export const TransactionTypes = {
    CHARGE_CORPORATE: "افزایش شارژ شرکت",
    CHARGE_USER: "افزایش شارژ کیف پول",
    GIFT: "افزایش کیف پول با هدیه",
    PERSONNEL_USE_CREDIT: "استفاده از اعتبار شرکت به پرسنل",
    CORPORATE_PERSONNEL_USE_CREDIT: "استفاده از اعتبار شرکت",
    USER_USE_BALANCE: "استفاده از کیف پول",
    PLACE_SETTLEMENT: "تسویه حساب با مجموعه",
    PLACE_SUBSCRIBE_SETTLEMENT: "پرداخت عضویت به مجموعه",
    COMMISSION:"کمیسیون"
}
